export default __webpack_public_path__ + "static/media/logo_verticale.87f53239.svg";